var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOneMileBuffer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 42
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Path 324"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M32.887 0 42 24.631 28.012 42 2.655 32.184l-2.654-21.5 21.415 6.831Z",
  "data-name": "Path 1127"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e8aa51",
  d: "m31.887 8.825-8.79 13.418-18.363-5.849L6.33 29.315l20.4 7.9 10.73-13.324zm1-8.826 9.112 24.631L28.012 42 2.655 32.184l-2.654-21.5 21.415 6.831Z",
  "data-name": "Path 1128"
}))));
export default SvgOneMileBuffer;